import ContatoTipoService from "../../services/ContatoTipoService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormContatoTipo from "../../pages/ContatoTipo/FormContatoTipo";
import Permissao from "../../controllers/Permissao";

export default class SelectContatoTipo extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(88));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de Contato Tipo',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormContatoTipo,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idContatoTipo) {
                        this.handleOpenSearch(null, response.data?.idContatoTipo);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();
        this.getOptions(() => {
            if (this.dispachChangeDidMount && this.props.value) {
                this.handleChange({ target: { value: this.props.value, name: this.props.name } });
            }
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {

        ContatoTipoService.getForCombo((response) => {
            this.setState({ options: response }, () => {
                if (callBack) {
                    callBack();
                }
            });
        });
    }

    render() {
        return super.render();
    }
}